import { FC } from 'react'
import * as styles from 'components/features/pfm/LinkedAccounts/OrderBy.styl'
import cn from 'classnames'

export type SortDirection = 'asc' | 'desc'

export type SortParam = 'providerName' | 'name' | 'amount' | 'categoryName'
export type SortProps = {
  sortBy: SortParam
  direction: SortDirection
}

type OrderByProps = {
  direction: SortDirection | null
  onClick?: () => void
}

export const OrderBy: FC<OrderByProps> = (props) => {
  const { children, direction, onClick } = props

  const className = cn(styles.orderBy, direction && styles[direction])

  return (
    <button className={ className } onClick={ onClick }>
      <div className={ styles.title }>
        { children }
      </div>
      <div className={ styles.direction }>
        <div className={ styles.arrowUp }>&#9650;</div>
        <div className={ styles.arrowDown }>&#9660;</div>
      </div>
    </button>
  )
}
